import { IGameState } from '../../../../State/Game/IGameState';
import Game from '../../../../Game';
import { FBTrackingEvent } from '../../../../Utility/Tracking/FBTrackingEvent';
import { PlayerActions } from '../../../../State/Player/PlayerActions';
import { sendEvent, track } from '../../../../Utility/Tracking/Track';
import { FTUXTrackingEventName } from '../../../../Utility/Tracking/TrackingEvent';

export function trackLevelStartShown(props: { levelNumber: number }): void {
    const state: IGameState = Game.store.getState();

    switch (props.levelNumber) {
        case 2:
            if (!state.playerState.FBEvents.includes(FBTrackingEvent.FTUE_07_Level2Play)) {
                Game.sdk.gameTracking(FBTrackingEvent.FTUE_07_Level2Play);
                PlayerActions.addFTUETrackingEvent(
                    FBTrackingEvent.FTUE_07_Level2Play,
                );

                track('stepId', 7);
                track('stepName', FBTrackingEvent.FTUE_07_Level2Play);
                sendEvent(FTUXTrackingEventName.ftux, Game.store.getState());
            }
            break;
        case 3:
            if (!state.playerState.FBEvents.includes(FBTrackingEvent.FTUE_10_Level3Play)) {
                Game.sdk.gameTracking(FBTrackingEvent.FTUE_10_Level3Play);
                PlayerActions.addFTUETrackingEvent(
                    FBTrackingEvent.FTUE_10_Level3Play,
                );

                track('stepId', 10);
                track('stepName', FBTrackingEvent.FTUE_10_Level3Play);
                sendEvent(FTUXTrackingEventName.ftux, Game.store.getState());
            }
            break;
        case 4:
            if (!state.playerState.FBEvents.includes(FBTrackingEvent.Level4PreLevelButtonPlay)) {
                Game.sdk.gameTracking(FBTrackingEvent.Level4PreLevelButtonPlay);
                PlayerActions.addFTUETrackingEvent(
                    FBTrackingEvent.Level4PreLevelButtonPlay,
                );
            }
            break;
        case 5:
            if (!state.playerState.FBEvents.includes(FBTrackingEvent.Level5PreLevelButtonPlay)) {
                Game.sdk.gameTracking(FBTrackingEvent.Level5PreLevelButtonPlay);
                PlayerActions.addFTUETrackingEvent(
                    FBTrackingEvent.Level5PreLevelButtonPlay,
                );
            }
            break;
        case 6:
            if (!state.playerState.FBEvents.includes(FBTrackingEvent.Level6PreLevelButtonPlay)) {
                Game.sdk.gameTracking(FBTrackingEvent.Level6PreLevelButtonPlay);
                PlayerActions.addFTUETrackingEvent(
                    FBTrackingEvent.Level6PreLevelButtonPlay,
                );
            }
            break;
        case 7:
            if (!state.playerState.FBEvents.includes(FBTrackingEvent.Level7PreLevelButtonPlay)) {
                Game.sdk.gameTracking(FBTrackingEvent.Level7PreLevelButtonPlay);
                PlayerActions.addFTUETrackingEvent(
                    FBTrackingEvent.Level7PreLevelButtonPlay,
                );
            }
            break;
    }
}

export function trackLevelEndShown(props: { levelNumber: number }): void {
    const state: IGameState = Game.store.getState();

    switch (props.levelNumber) {
        case 1:
            if (!state.playerState.FBEvents.includes(FBTrackingEvent.FTUE_05_Level1FinishPopupShow)) {
                Game.sdk.gameTracking(FBTrackingEvent.FTUE_05_Level1FinishPopupShow);
                PlayerActions.addFTUETrackingEvent(
                    FBTrackingEvent.FTUE_05_Level1FinishPopupShow,
                );

                track('stepId', 5);
                track('stepName', FBTrackingEvent.FTUE_05_Level1FinishPopupShow);
                sendEvent(FTUXTrackingEventName.ftux, Game.store.getState());
            }
            break;
        case 2:
            if (!state.playerState.FBEvents.includes(FBTrackingEvent.FTUE_09_Level2FinishPopupShow)) {
                Game.sdk.gameTracking(FBTrackingEvent.FTUE_09_Level2FinishPopupShow);
                PlayerActions.addFTUETrackingEvent(
                    FBTrackingEvent.FTUE_09_Level2FinishPopupShow,
                );

                track('stepId', 9);
                track('stepName', FBTrackingEvent.FTUE_09_Level2FinishPopupShow);
                sendEvent(FTUXTrackingEventName.ftux, Game.store.getState());
            }
            break;
        case 3:
            if (!state.playerState.FBEvents.includes(FBTrackingEvent.FTUE_12_Level3FinishPopupShow)) {
                Game.sdk.gameTracking(FBTrackingEvent.FTUE_12_Level3FinishPopupShow);
                PlayerActions.addFTUETrackingEvent(
                    FBTrackingEvent.FTUE_12_Level3FinishPopupShow,
                );

                track('stepId', 12);
                track('stepName', FBTrackingEvent.FTUE_12_Level3FinishPopupShow);
                sendEvent(FTUXTrackingEventName.ftux, Game.store.getState());
            }
            break;
        case 4:
            if (!state.playerState.FBEvents.includes(FBTrackingEvent.Level04FinishPopupShow)) {
                Game.sdk.gameTracking(FBTrackingEvent.Level04FinishPopupShow);
                PlayerActions.addFTUETrackingEvent(
                    FBTrackingEvent.Level04FinishPopupShow,
                );
            }
            break;
        case 5:
            if (!state.playerState.FBEvents.includes(FBTrackingEvent.Level05FinishPopupShow)) {
                Game.sdk.gameTracking(FBTrackingEvent.Level05FinishPopupShow);
                PlayerActions.addFTUETrackingEvent(
                    FBTrackingEvent.Level05FinishPopupShow,
                );
            }
            break;
        case 6:
            if (!state.playerState.FBEvents.includes(FBTrackingEvent.Level06FinishPopupShow)) {
                Game.sdk.gameTracking(FBTrackingEvent.Level06FinishPopupShow);
                PlayerActions.addFTUETrackingEvent(
                    FBTrackingEvent.Level06FinishPopupShow,
                );
            }
            break;
        case 7:
            if (!state.playerState.FBEvents.includes(FBTrackingEvent.Level07FinishPopupShow)) {
                Game.sdk.gameTracking(FBTrackingEvent.Level07FinishPopupShow);
                PlayerActions.addFTUETrackingEvent(
                    FBTrackingEvent.Level07FinishPopupShow,
                );
            }
            break;
    }
}

export function trackFtuxOnHide(props: { levelNumber: number }): void {
    const state: IGameState = Game.store.getState();

    if (!state.playerState.FBEvents.includes(FBTrackingEvent.FTUE_06_Level1Continue) && props.levelNumber === 1) {
        Game.sdk.gameTracking(FBTrackingEvent.FTUE_06_Level1Continue);
        PlayerActions.addFTUETrackingEvent(
            FBTrackingEvent.FTUE_06_Level1Continue,
        );

        track('stepId', 6);
        track('stepName', FBTrackingEvent.FTUE_06_Level1Continue);
        sendEvent(FTUXTrackingEventName.ftux, Game.store.getState());
    }

    switch (props.levelNumber) {
        case 1:
            if (!state.playerState.FBEvents.includes(FBTrackingEvent.FTUE_07_Level2Play)) {
                Game.sdk.gameTracking(FBTrackingEvent.FTUE_07_Level2Play);
                PlayerActions.addFTUETrackingEvent(
                    FBTrackingEvent.FTUE_07_Level2Play,
                );

                track('stepId', 7);
                track('stepName', FBTrackingEvent.FTUE_07_Level2Play);
                sendEvent(FTUXTrackingEventName.ftux, state);
            }
            break;
        case 2:
            if (!state.playerState.FBEvents.includes(FBTrackingEvent.FTUE_10_Level3Play)) {
                Game.sdk.gameTracking(FBTrackingEvent.FTUE_10_Level3Play);
                PlayerActions.addFTUETrackingEvent(
                    FBTrackingEvent.FTUE_10_Level3Play,
                );

                track('stepId', 10);
                track('stepName', FBTrackingEvent.FTUE_10_Level3Play);
                sendEvent(FTUXTrackingEventName.ftux, state);
            }
            break;
    }
}
